import React, { useState, useEffect } from 'react';

const PasswordProtection = ({ onSuccess, children }) => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLocalhost, setIsLocalhost] = useState(false);
  const [error, setError] = useState('');

  // Check if we're on localhost
  useEffect(() => {
    const isLocal = window.location.hostname === 'localhost' || 
                   window.location.hostname === '127.0.0.1' ||
                   window.location.hostname.includes('localhost');
    setIsLocalhost(isLocal);
  }, []);

  // Check if already authenticated (stored in sessionStorage)
  useEffect(() => {
    const authenticated = sessionStorage.getItem('itora_authenticated');
    if (authenticated === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Replace 'your-password-here' with your actual password
    if (password === 'iterate0') {
      setIsAuthenticated(true);
      sessionStorage.setItem('itora_authenticated', 'true');
      setError('');
      if (onSuccess) onSuccess();
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };

  // If on localhost, show content without password
  if (isLocalhost) {
    return children;
  }

  // If authenticated, show content
  if (isAuthenticated) {
    return children;
  }

  // Show password protection screen
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'var(--c5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      fontFamily: 'var(--font-b)'
    }}>
      <div style={{
        textAlign: 'center',
        maxWidth: '400px',
        padding: '40px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
      }}>
        <h1 
        className='f-a'
        style={{
          color: 'var(--c00)',
          marginBottom: '30px',
          fontSize: '24px',
          fontWeight: '600',
          fontFamily: 'var(--font-b)'
        }}>
          ITORA Beta Access
        </h1>
        
        <p style={{
          color: '#666',
          marginBottom: '30px',
          fontSize: '14px',
          fontFamily: 'var(--font-b)'
        }}>
          Enter password to access the site
        </p>

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '2px solid #e0e0e0',
              borderRadius: '8px',
              fontSize: '16px',
              fontFamily: 'var(--font-b)',
              outline: 'none',
              transition: 'border-color 0.2s',
              boxSizing: 'border-box'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = 'var(--c5)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#e0e0e0';
            }}
          />
          
          {error && (
            <p style={{
              color: '#e74c3c',
              fontSize: '14px',
              marginTop: '8px',
              fontFamily: 'var(--font-b)'
            }}>
              {error}
            </p>
          )}
          
          <button
            type="submit"
            style={{
              width: '100%',
              padding: '12px 16px',
              backgroundColor: 'var(--c5)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              fontFamily: 'var(--font-b)',
              cursor: 'pointer',
              marginTop: '16px',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#5a4fd8';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'var(--c5)';
            }}
          >
            Enter
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordProtection; 